<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.name }}
        </p>
        <span class="user-status">{{
          userData.role == 'master'
            ? 'Master'
            : userData.role == 'admin'
              ? 'Administrador'
              : userData.role == 'user'
                ? 'Usuário'
                : ''
        }}</span>
      </div>
      <b-avatar
        size="40"
        v-show="
          !(userData.foto && userData.foto.foto) && userData.genero == 'M'
        "
        :src="require('@/assets/images/avatars/13-small.png')"
        variant="light-primary"
        class="badge-minimal"
        badge-variant="success"
      >
      </b-avatar>
      <b-avatar
        size="40"
        v-show="
          !(userData.foto && userData.foto.foto) && userData.genero == 'F'
        "
        :src="require('@/assets/images/avatars/11-small.png')"
        variant="light-primary"
        class="badge-minimal"
        badge-variant="success"
      >
      </b-avatar>
      <b-avatar
        size="40"
        v-show="userData.foto && userData.foto.foto"
        :src="userData.foto && userData.foto.foto"
        variant="light-primary"
        class="badge-minimal"
        badge-variant="success"
      >
      </b-avatar>
    </template>

    <b-dropdown-item
      v-show="showUserConfig"
      :to="{ name: 'ConfiguracoesPerfil' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="UserIcon" class="mr-100" />
      <span>Perfil</span>
    </b-dropdown-item>

    <b-dropdown-divider v-show="showUserConfig" />

    <b-dropdown-item
      :to="{ name: 'centralapoio' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="20" icon="HelpCircleIcon" class="mr-100" />
      <span> Ajuda</span>
    </b-dropdown-item>
    <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
      <feather-icon size="16" icon="LogOutIcon" class="mr-100" />
      <span> Logout</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BImg,
} from 'bootstrap-vue';
import useJwt from '@/auth/jwt/useJwt';
import { avatarText } from '@core/utils/filter';
import { mapGetters } from 'vuex';
export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BImg,
  },
  computed: {
    ...mapGetters({
      userData: 'user/userData',
      hasPermissao: 'user/hasPermissao',
    }),
  },
  data() {
    return {
      avatarText,
      showUserConfig: function () {
        return (
          this.userData?.role == 'master' ||
          this.hasPermissao('ConfiguracoesPerfil')
        );
      },
    };
  },
  mounted() {
    if (this.userData) {
      this.$root.$on('atualizarFotoDropDown', item => {
        // this.userData = JSON.parse(localStorage.getItem("userData"));
      });
    }
  },
  methods: {
    logout() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      useJwt.clearUserLocalStorage();
      // Redirect to login page
      this.$router.push({ name: 'auth-login' });
    },
  },
  watch: {
    userData: function () {
      this.showUserConfig =
        this.userData?.role == 'master' ||
        this.hasPermissao('ConfiguracoesPerfil');
    },
  },
};
</script>
